const paths = {
    INTRO_SCREEN: '/',
    AUTH_SCREEN: '/auth',
    FORGOT_PASSWORD_SCREEN: '/forgotpassword',
    ENTER_OTP_SCREEN: '/enterotp',
    CHANGE_PASSWORD_SCREEN: '/changepassword',
    HOME_SCREEN: '/home',
    PROJECT_SCREEN: '/projects',
    PROJECT_DETAIL: '/projects-detail',
    ADD_PROJECT: '/add-project',
    MY_PROFILE: '/my-profile',
    YOUR_PROGRESS: '/your-progress',
    POINTS_DASHBOARD: '/your-progress/points-dashboard',
    LEVEL_JOURNEY: '/your-progress/levels',
    STREAKS_JOURNEY: "/your-progress/streaks",
    BADGES_PANEL: "/your-progress/badges",
    REWARD_PANEL: "/your-progress/rewards",
    TERMS: '/termsconditions',
    PRIVACY: '/privacypolicy',
    DELETEINSTRUCTION: '/deleteInstruction',
    SHOP: '/shop',
    FAQ: '/faq',
    SHUFFLE: '/shuffle',
    ABOUTUS: '/about',
    SEARCH: '/search',
    EDIT_PROJECT: '/edit-project',
    LEADERBOARD:'/leaderboard',
    REWARD_DETAIL:'/reward-detail'
};


export default paths;